import { __assign, __awaiter, __generator } from "tslib";
import * as React from 'react';
import { findInPopover } from '../../common/find-in-popover';
import { renderAndMountComponent } from '@wix/answers-lib';
import { ImageUploader } from './image-uploader.comp';
import { getBaseReactDriver } from '../../common/base-driver';
import { createLegacyDeprecatedInputDriver } from '../../primitives/deprecated-input/input.legacy-driver';
export var createImageUploaderDriver = function (elemOrLegacyBaseDriver) {
    var base = getBaseReactDriver(elemOrLegacyBaseDriver);
    return {
        getImageURL: function () { return base.find('.image-container').getDataAttr('image-url'); },
        addImageFromWeb: function (url) { return __awaiter(void 0, void 0, void 0, function () {
            var uploadPopover, inputDriver;
            return __generator(this, function (_a) {
                base.find('.add-button').click();
                uploadPopover = findInPopover('.upload-image-popover-body');
                uploadPopover.find('.image-from-web').click();
                inputDriver = createLegacyDeprecatedInputDriver(uploadPopover.elem);
                inputDriver.enterValue(url);
                uploadPopover.find('.save-button').click();
                return [2 /*return*/];
            });
        }); },
        changeImageFromWebUrl: function (url) { return __awaiter(void 0, void 0, void 0, function () {
            var uploadPopover, inputDriver;
            return __generator(this, function (_a) {
                uploadPopover = findInPopover('.upload-image-popover-body');
                inputDriver = createLegacyDeprecatedInputDriver(uploadPopover.elem);
                inputDriver.enterValue(url);
                uploadPopover.find('.save-button').click();
                return [2 /*return*/];
            });
        }); },
        isUrlValidationErrorDisplayed: function () {
            var popoverVisible = base.find('.add-button').hasClass('show');
            if (popoverVisible) {
                var uploadPopover = findInPopover('.upload-image-popover-body');
                var inputDriver = createLegacyDeprecatedInputDriver(uploadPopover.elem);
                return inputDriver && !inputDriver.isValid();
            }
            else {
                return false;
            }
        },
        getProgressPercentage: function () { return parseInt(base.find('.progress-percentage').getText(), 10); },
        isUploadError: function () { return base.isChildVisible('.error-state'); },
        base: base
    };
};
export var renderImageUploaderAndReturnDriver = function (props) {
    var elem = renderAndMountComponent(React.createElement(ImageUploader, __assign({}, props)));
    return createImageUploaderDriver(elem);
};
//# sourceMappingURL=image-uploader.driver.js.map